<template>
	<div class="box-page">
		<div class="row">

			<div class="col-12 pl-0 pr-0 d-flex flex-wrap">
				<div class="col-12 col-lg-6 pl-0 pr-0 pt-3 pt-lg-0 order-2 order-lg-1">
					<div class="col-12 pl-0 pr-0 d-lg-flex">
						<div class="col-12 pl-0 pr-0 pr-lg-3">
							<div class="col-12 d-flex bg-white color-blue rounded-cus cus-box-shadow">
								<div class="col-12 col-md-6 mt-auto mb-auto pl-0 pr-0 pt-2 pb-2">
									<div class="col-12 pl-2 font-size-12 font-size-sm-11 font-weight-bold" v-if="userData">
										Hai, {{ userData.stockist_name }}!</div>
									<div class="col-12 pl-2 font-size-10">Selamat Datang di POS Mobile Counter</div>
									<BtnShareStore v-if="false"></BtnShareStore>
									<div class="col-12 pl-2 font-size-12 font-size-sm-11 pt-2 pb-2"
										v-if="userData.stockist_trx_method !== 'system'">Saat ini Anda menggunakan <span
											class="font-weight-bold">Transaksi Non Sistem. </span>
										Untuk menikmati Fitur secara Lengkap POS Mobile Counter, silakan beralih menggunakan Metode Transaksi
										Sistem</div>
								</div>
								<div class="col-6 d-none d-md-block text-center">
									<img class="img-fluid img-welcome" src="/assets/login/ilustrasi-login.svg">
								</div>
							</div>
							<div class="col-12 pl-0 pr-0 cus-box-shadow bg-white rounded-cus mt-3"
								v-show="Object.values(dataPenjualan).length == 0">
								<vcl :width='300' :height='63'>
									<rect x="237" y="5" rx="2" ry="2" width="52" height="12" />
									<rect x="7" y="20" rx="2" ry="2" width="90" height="27" />
									<rect x="103" y="20" rx="2" ry="2" width="90" height="27" />
									<rect x="200" y="20" rx="2" ry="2" width="90" height="27" />
								</vcl>
							</div>
							<div class="col-12 pl-0 pr-0 cus-box-shadow bg-white rounded-cus mt-3"
								v-if="Object.values(dataPenjualan).length > 0">
								<div class="col-12 pl-0 pr-0 pt-3 d-flex">
									<div class="col-6 col-md-9 font-size-16 font-size-sm-12 font-weight-bold color-light-black mt-auto mb-auto">
										Dashboard</div>
									<div class="col-6 col-md-3 pl-0">
										<div class="dropdown">
											<button class="col-12 pl-3 pr-3 btn bg-white cus-box-shadow rounded-cus box-blue" type="button"
												data-toggle="dropdown">
												<div class="font-size-10 d-flex justify-content-between">
													<span>{{ penjualanMitra }}</span>
													<i class="fas fa-chevron-down mt-auto mb-auto"></i>
												</div>
											</button>
											<div class="col-12 dropdown-menu dropdown-mila font-size-10">
												<a class="dropdown-item pl-3" href="javascript:;" v-for="(limit, index) in pilihanStatusSerial"
													:key="index" @click="penjualan({ limit, index })">{{ limit }}</a>
											</div>
										</div>
									</div>
								</div>
								<div class="col-12 pl-0 pr-0 pt-2" v-if="Object.values(dataPenjualan).length > 0">
									<carousel ref="carousel" id="owl-menu" class="col-12 pl-0 pr-0"
										:responsive="{ 0: { items: 1 }, 600: { items: 1 }, 1000: { items: 1 } }" :margin="0" :autoplay="true"
										:nav="false" :loop="false" :dots="true" :autoplayTimeout=7000 :autoplayHoverPause="true">
										<div class="col-12 background-white rounded d-md-flex pt-1 pb-1">
											<div class="col-12 col-md-4 pl-0 pr-0 pr-md-2">
												<div class="col-12 bg-white rounded-cus cus-box-shadow d-flex card-info">
													<div class="col-8 pl-0 pr-0 m-auto text-sales">
														<div class="col-12 pl-0 pr-0 font-size-9">Total Penjualan (Rp)</div>
														<div v-if="dataPenjualan.transaction.all"
															class="col-12 pl-0 pr-0 font-size-11 font-weight-bold"> {{
																dataPenjualan.transaction.all | toNumber }} </div>
														<div v-else class="col-12 pl-0 pr-0 font-size-11 font-weight-bold">0</div>
													</div>
													<div class="col-4 pr-0 m-auto text-right text-md-center box-img-sales">
														<img class="img-sales d-inline-block"
															src="/assets/dashboard/ilustrasi-tab-penjualan.svg">
													</div>
												</div>
											</div>
											<div class="col-12 col-md-4 pl-0 pr-0 pt-2 pt-md-0">
												<div class="col-12 bg-white rounded-cus cus-box-shadow d-flex card-info">
													<div class="col-8 pl-0 pr-0 m-auto text-sales">
														<div class="col-12 pl-0 pr-0 font-size-9">Penjualan Mitra (Rp)</div>
														<div v-if="dataPenjualan.transaction.member"
															class="col-12 pl-0 pr-0 font-size-11 font-weight-bold">{{
																dataPenjualan.transaction.member | toNumber }}</div>
														<div v-else class="col-12 pl-0 pr-0 font-size-11 font-weight-bold">0</div>
													</div>
													<div class="col-4 pr-0 m-auto text-right text-md-center box-img-sales">
														<img class="img-sales d-inline-block"
															src="/assets/dashboard/ilustrasi-tab-penjualan-mitra.svg">
													</div>
												</div>
											</div>
											<div class="col-12 col-md-4 pl-0 pl-md-2 pr-0 pt-2 pt-md-0">
												<div class="col-12 bg-white rounded-cus cus-box-shadow d-flex card-info">
													<div class="col-8 pl-0 pr-0 m-auto text-sales">
														<div class="col-12 pl-0 pr-0 font-size-9">Penjualan Mitra Baru (Rp)</div>
														<div v-if="dataPenjualan.transaction.new_member"
															class="col-12 pl-0 pr-0 font-size-11 font-weight-bold">{{
																dataPenjualan.transaction.new_member | toNumber }}</div>
														<div v-else class="col-12 pl-0 pr-0 font-size-11 font-weight-bold">0</div>
													</div>
													<div class="col-4 pr-0 m-auto text-right text-md-center box-img-sales">
														<img class="img-sales d-inline-block"
															src="/assets/dashboard/ilustrasi-tab-penjualan-mitra-baru.svg">
													</div>
												</div>
											</div>
										</div>
										<div class="col-12 background-white rounded d-md-flex pt-1 pb-1">
											<div class="col-12 col-md-4 pl-0 pr-0 pr-md-2">
												<div class="col-12 bg-white rounded-cus cus-box-shadow d-flex card-info">
													<div class="col-8 pl-0 pr-0 m-auto text-sales">
														<div class="col-12 pl-0 pr-0 font-size-9">Total Transaksi (Qty)</div>
														<div v-if="dataPenjualan.quantity.all"
															class="col-12 pl-0 pr-0 font-size-11 font-weight-bold"> {{ dataPenjualan.quantity.all
																| toNumber }} </div>
														<div v-else class="col-12 pl-0 pr-0 font-size-11 font-weight-bold">0</div>
													</div>
													<div class="col-4 pr-0 m-auto text-center box-img-sales">
														<img class="img-sales d-inline-block"
															src="/assets/dashboard/ilustrasi-tab-penjualan.svg">
													</div>
												</div>
											</div>
											<div class="col-12 col-md-4 pl-0 pr-0 pt-2 pt-md-0">
												<div class="col-12 bg-white rounded-cus cus-box-shadow d-flex card-info">
													<div class="col-8 pl-0 pr-0 m-auto text-sales">
														<div class="col-12 pl-0 pr-0 font-size-9">Transaksi Mitra (Qty)</div>
														<div v-if="dataPenjualan.quantity.member"
															class="col-12 pl-0 pr-0 font-size-11 font-weight-bold">{{
																dataPenjualan.quantity.member | toNumber }}</div>
														<div v-else class="col-12 pl-0 pr-0 font-size-11 font-weight-bold">0</div>
													</div>
													<div class="col-4 pr-0 m-auto text-center box-img-sales">
														<img class="img-sales d-inline-block"
															src="/assets/dashboard/ilustrasi-tab-penjualan-mitra.svg">
													</div>
												</div>
											</div>
											<div class="col-12 col-md-4 pl-0 pl-md-2 pr-0 pt-2 pt-md-0">
												<div class="col-12 bg-white rounded-cus cus-box-shadow d-flex card-info">
													<div class="col-8 pl-0 pr-0 m-auto text-sales">
														<div class="col-12 pl-0 pr-0 font-size-9">Transaksi Mitra Baru (Qty)</div>
														<div v-if="dataPenjualan.quantity.new_member"
															class="col-12 pl-0 pr-0 font-size-11 font-weight-bold">{{
																dataPenjualan.quantity.new_member | toNumber }}</div>
														<div v-else class="col-12 pl-0 pr-0 font-size-11 font-weight-bold">0</div>
													</div>
													<div class="col-4 pr-0 m-auto text-center box-img-sales">
														<img class="img-sales d-inline-block"
															src="/assets/dashboard/ilustrasi-tab-penjualan-mitra-baru.svg">
													</div>
												</div>
											</div>
										</div>
									</carousel>
								</div>
							</div>
						</div>
					</div>

					<div class="col-12 pt-3 pl-0 pr-0 d-lg-flex">
						<div class="col-12 pl-0 pr-0 pt-lg-0 pr-lg-3">
							<div class="col-12 bg-white rounded-cus cus-box-shadow pb-2 pb-md-0">
								<div class="col-12 pl-0 pr-0 pt-3 pb-2 d-flex border-bottom border-medium border-light-black">
									<div class="col-9 pl-0 pr-0 d-flex text-uppercase font-size-8 font-weight-bold">
										<div class="col-8 col-md-5 pl-0" v-if="dataPenjualanByYear.length > 0 || dataPenjualanByYear == 'error'">
											total penjualan (Qty)</div>
										<div class="col-8 col-md-4 pl-0" v-show="dataPenjualanByYear.length == 0">
											<vcl :width='300' :height='30'>
												<rect x="0" y="0" rx="2" ry="2" width="300" height="30" />
											</vcl>
										</div>
										<!-- <div class="col-9 pl-0 pr-0 d-flex text-center">
											<div class="col-4 pl-0 cursor-pointer" v-for="(produk,index) in dataProduct" :key="index" @click="dataByProduk(produk.product_id)" :class="{'title-active': grafik== produk.product_id}">{{ produk.product_name }}</div>
										</div> -->
									</div>
									<!-- <div class="col-3 pr-0 d-flex font-size-8 font-weight-bold">
										<div class="col-6 pl-0 color-blue"><i class="fas fa-square mr-1"></i><span></span></div>
										<div class="col-6 pl-0 pr-0 color-light-black"><i class="fas fa-square mr-1"></i><span>Payment</span></div>
									</div> -->
								</div>
								<div class="col-12 pl-0 pr-0" v-show="dataPenjualanByYear.length == 0">
									<vcl :width='300' :height='110'>
										<rect x="0" y="10" rx="2" ry="2" width="300" height="90" />
									</vcl>
								</div>
								<div class="col-12 pl-0 pr-0" v-if="dataPenjualanByYear == 'error'">
									<div class="col-12 pt-3 pb-3 text-center">
										<div class="col-6 col-md-4 ml-auto mr-auto">
											<img class="img-fluid" src="/assets/report/ilustrasi-data-kosong-report.png">
										</div>
										<div class="font-size-11 pt-1">Data tidak tersedia!</div>
									</div>
								</div>
								<div class="col-12 pl-0 pr-0" v-else>
									<i-chart :chartData='chartData'></i-chart>
								</div>
							</div>
							<div class="col-12 bg-white rounded-cus cus-box-shadow" v-if="false">
								<div class="col-12 pl-0 pr-0 pt-3 pb-3 d-flex border-bottom border-medium border-light-black">
									<div class="col-9 pl-0 pr-0 d-flex text-uppercase font-size-8 font-weight-bold overflow-auto">
										<div class="col-3 pl-0 cursor-pointer">Pendaftaran</div>
									</div>
								</div>
								<div class="col-12 pl-0 pr-0">
									<d-chart></d-chart>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="col-12 col-lg-6 pl-0 pr-0 d-flex order-1 order-lg-2">
					<div class="col-12 pl-0 pr-0 pr-lg-3 pt-3 pt-lg-0" v-if="dataStockProduct == 'error'">
						<div class="col-12 pb-2 bg-white rounded-cus cus-box-shadow">
							<div class="col-12 pt-3 pb-3 pl-0 pr-0 pl-md-2 pr-md-2 d-flex">
								<div class="col-12 pl-0 mt-auto mb-auto font-size-sm-11">Stok Produk</div>
							</div>
							<div class="col-12 pl-0 pr-0 dash-method-pay">
								<div class="col-12 pt-3 pb-3 text-center">
									<div class="col-6 col-md-4 ml-auto mr-auto">
										<img class="img-fluid" src="/assets/report/ilustrasi-data-kosong-report.png">
									</div>
									<div class="font-size-11 pt-1">Data tidak tersedia!</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-12 pl-0 pr-0 pr-lg-3 pt-3 pt-lg-0" v-else>
						<div class="col-12 pb-3 bg-white rounded-cus cus-box-shadow h-100">
							<div class="col-12 pt-3 pb-3 pl-0 pr-0 pl-md-2 pr-md-2 d-flex">
								<div class="col-12 pl-0 mt-auto mb-auto font-size-sm-11">Produk Mobile Counter Saya</div>
							</div>
							<div class="col-12 pl-0 pr-0 dash-cart">
								<div class="col-12 pb-3 pl-0 pr-0 d-flex">
									<div class="col-9">Nama Barang</div>
									<div class="col-3 text-right">Stok Tersedia</div>
								</div>
								<div class="col-12 pb-2 pl-0 pr-0 pl-md-2 d-flex" v-for="(stock, index) in dataProduk" :key="index">
									<div class="col-2 pl-0">
										<div class="pt-1 icon-payment bg-pos rounded-cus">
											<img :src="stock.product_image_filename">
										</div>
									</div>
									<div class="col-7 mt-auto mb-auto">
										<div class="col-12 font-size-11 font-size-sm-10 text-capitalize">{{ stock.product_name }}</div>
										<div class="col-12 color-mila font-size-10 font-bold">Rp {{ stock.product_price | toNumber }}</div>
									</div>
									<div class="col-3 text-right mt-auto mb-auto">
										<div :class="stock.stock_pos | toColorProduct">{{ stock.stock_pos | toNumber }}</div>
										<button class="btn btn-blue rounded-cus box-purple" :disabled="stock.stock_pos <= 0" @click="addToCart(stock.product_code)">
											<div class="font-size-8 text-uppercase" v-if="stock.stock_pos > 0">Jual sekarang</div>
											<div class="font-size-8 text-uppercase" v-else >Kosong</div>
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="col-12 pt-0 pt-lg-3 pl-0 pr-0 d-lg-flex">
				<div class="col-12 col-lg-12 pl-0 pr-0 pt-3 pt-lg-0" v-if="mitra.length == 0">
					<div class="col-12 pb-3 bg-white rounded-cus cus-box-shadow">
						<div class="col-12 pt-3 pb-3 pl-2 pr-2">
							<vcl :width='300' :height='156'>
								<rect x="5" y="5" rx="2" ry="2" width="80" height="13" />
								<rect x="5" y="30" rx="2" ry="2" width="100" height="9" />
								<rect x="5" y="42" rx="2" ry="2" width="70" height="9" />
								<rect x="5" y="53" rx="2" ry="2" width="50" height="9" />
								<rect x="200" y="30" rx="2" ry="2" width="90" height="18" />
								<rect x="5" y="75" rx="2" ry="2" width="100" height="9" />
								<rect x="5" y="87" rx="2" ry="2" width="70" height="9" />
								<rect x="5" y="98" rx="2" ry="2" width="50" height="9" />
								<rect x="200" y="78" rx="2" ry="2" width="90" height="18" />
								<rect x="5" y="120" rx="2" ry="2" width="100" height="9" />
								<rect x="5" y="132" rx="2" ry="2" width="70" height="9" />
								<rect x="5" y="144" rx="2" ry="2" width="50" height="9" />
								<rect x="200" y="122" rx="2" ry="2" width="90" height="18" />
							</vcl>
						</div>
					</div>
				</div>
				<div class="col-12 col-lg-5 pl-0 pr-0 pt-lg-0" v-else-if="mitra == 'error'">
					<div class="col-12 bg-white rounded-cus cus-box-shadow">
						<div class="col-12 pt-3 pb-3 pl-0 pr-0 pl-md-2 pr-md-2 d-flex">
							<div class="col-8 col-md-6 pl-0 mt-auto mb-auto font-size-sm-11">{{ filter_mitra }}</div>
						</div>
						<div class="col-12 pl-0 pr-0 dash-new-mitra">
							<div class="col-12 pt-3 pb-3 text-center">
								<div class="col-6 col-md-4 ml-auto mr-auto">
									<img class="img-fluid" src="/assets/report/ilustrasi-data-kosong-report.png">
								</div>
								<div class="font-size-11 pt-1">Data tidak tersedia!</div>
							</div>
						</div>
					</div>
				</div>

				<div class="col-12 col-lg-12 pl-0 pr-0 pt-3 pt-lg-0" v-else>
					<div class="col-12 pb-3 bg-white rounded-cus cus-box-shadow">
						<div class="col-12 pt-3 pb-3 pl-0 pr-0 pl-md-2 pr-md-2 d-flex">
							<div class="col-8 col-md-6 pl-0 mt-auto mb-auto font-size-sm-11">{{ filter_mitra }}</div>
							<div class="col-4 col-md-6 pr-0 text-right">
								<div class="btn-group">
									<button type="button" class="btn bg-white rounded-pill box-blue" data-toggle="dropdown">
										<div class="pl-1 pr-1 color-gray-2 font-size-12"><i class="fas fa-ellipsis-v"></i></div>
									</button>
									<div class="dropdown-menu dropdown-menu-right dropdown-mila">
										<button class="dropdown-item" type="button" @click="getDataMitra(0, 'Data Mitra Baru')"><span
												class="font-size-9">Mitra baru</span></button>
										<button class="dropdown-item" type="button" @click="getDataMitra(1, 'Data Pendaftaran')"><span
												class="font-size-9">Pendaftaran</span></button>
										<button class="dropdown-item" type="button" @click="getDataMitra(2, 'Data Semua Mitra')"><span
												class="font-size-9">Semua mitra</span></button>
									</div>
								</div>
							</div>
						</div>
						<div class="col-12 pl-0 pr-0 dash-new-mitra">
							<div class="col-12 pb-2 pl-0 pl-md-2 pr-0 d-flex" v-for="(mitras, index) in mitra" :key="index">
								<div class="col-6 pl-0 pr-0 pr-md-3">
									<div class="col-12 pl-0 pr-0">
										<span class="color-gray-2 font-size-9">Kode Sponsor</span>
										<span class="color-light-blue font-size-10 pl-1">{{ mitras.register_sponsor_code }}</span>
									</div>
									<div class="col-12 pl-0 pr-0 font-size-10 font-weight-bold">{{ mitras.register_member_name }}</div>
									<div class="col-12 pl-0 font-size-9">{{ mitras.register_member_phone }}</div>
								</div>
								<div class="col-6 pr-md-3 pr-1">
									<BadgeMitra :type='mitras.register_status'></BadgeMitra>
									<div class="col-12 pt-1 pl-0 pr-0 text-right font-italic font-size-9 color-gray-2"
										v-if="mitras.register_status == 'pending'">
										<div class="col-12 pl-0 pr-0 pr-md-3">Transaksi {{ mitras.register_datetime | toTanggal }}</div>
										<div class="col-12 pl-0 pr-0 pr-md-3">Belum Terdaftar</div>
									</div>
									<div class="col-12 pt-1 pl-0 pr-0 text-right font-italic font-size-9 color-gray-2"
										v-if="mitras.register_status == 'waiting'">
										<div class="col-12 pl-0 pr-0 pr-md-3">Transaksi {{ mitras.register_datetime | toTanggal }}</div>
										<div class="col-12 pl-0 pr-0 pr-md-3">Belum mengisi form</div>
									</div>
									<div class="col-12 pt-1 pl-0 pr-0 text-right font-italic font-size-9 color-gray-2"
										v-if="mitras.register_status == 'registered'">
										<div class="col-12 pl-0 pr-0 pr-md-3">Transaksi {{ mitras.register_datetime | toTanggal }}</div>
										<div class="col-12 pl-0 pr-0 pr-md-3">Terdaftar {{ mitras.register_api_mlm_datetime | toTanggal }}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<IModal ref="modalAlamatDashboard" type="modal-xl" :closeable="false">
			<template v-slot:title>
				<div class="text-center">
					Tambahkan Alamat Anda
				</div>
			</template>
			<template v-slot:body class="font-size-11">
				<FormAddress info></FormAddress>
			</template>
			<template v-slot:footer>
				<div class="row">
					<div class="col-10 offset-1 col-md-4 offset-md-4 text-center pt-md-3 pb-3">
						<button @click="simpanAlamat()"
							class="btn btn-blue color-white no-box-focus rounded-cus btn-block text-white font-size-10"><img
								src="/assets/icon/simpan.png" class="pr-2 img-fluid mt-n1">SIMPAN</button>
					</div>
				</div>
			</template>
		</IModal>
	</div>
</template>

<script>
import IModal from '@/components/IModal'
import FormAddress from '@/components/FormAddress'
import carousel from 'vue-owl-carousel';
import IChart from '@/components/chart/IChart.vue';
import BadgeMitra from '@/components/elements/BadgeMitra.vue';
import DChart from '@/components/chart/DChart.vue';
import BtnShareStore from '@/components/BtnShareStore.vue';
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'

export default {
	components: {
		IChart,
		DChart,
		carousel,
		BadgeMitra,
		IModal,
		FormAddress,
		BtnShareStore
	},
	name: 'Dashboard',
	data() {
		return {
			grafik: '',
			penjualanMitra: 'Semua',
			pilihanStatusSerial: ['Hari ini', 'Minggu ini', 'Bulan ini', 'Semua'],
			filter_mitra: 'Data Semua Mitra',
			payment: [
				{
					name: "uang tunai",
					qty: "25.000.000",
					percent: "30",
					img: "starterkit-mitra-usaha.png",
				},
				{
					name: "Debit BCA",
					qty: "67.000.000",
					percent: "35",
					img: "milagros-drinking-water.png",
				},
				{
					name: "Debit BNI",
					qty: "20.000.000",
					percent: "25",
					img: "milagros-spray.png",
				},
			],
		}
	},
	computed: {
		...mapState('dashboardList', ['mitra', 'dataPenjualan', 'dataPenjualanByYear', 'dataProduct', 'dataStockProduct', 'dataSortedStockProduct']),
		...mapState('cart', ['cart','dataProduk']),
		...mapState('auth', ['userData']),
		...mapGetters('auth', ['isAuth']),
		...mapGetters('dashboardList', ['chartData', 'chartDataProduct']),
		...mapState('commonList', ['province', 'city', 'subdistrict', 'paramsAddress']),
		...mapState('maps', ['location']),
		...mapState('profileList', ['konfirmasiSukses', 'responSukses']),
	},

	methods: {
		...mapActions('dashboardList', ['getMitra', 'getPenjualan', 'getPenjualanByYear', 'getdataByProduk', 'getSummaryStockProduct']),
		...mapActions('cart', ['getDataProduk','saveCart']),
		...mapActions('profileList', ['saveAddress']),
		...mapMutations('profileList', ['clearDataProfile']),
		...mapMutations('auth', ['setProfileData']),

		getDataMitra(id, label) {
			this.filter_mitra = label
			this.getMitra({ 'filter': id })
		},
		penjualan(param) {
			this.penjualanMitra = param.limit
			this.getPenjualan({ 'filter': param.index })
		},
		dataByProduk(val) {
			this.grafik = val
			if (val <= 0) {
				this.getPenjualanByYear()
			} else {
				this.getdataByProduk({ 'product_id': val })
			}
		},
		simpanAlamat() {
			var params = {
				address: this.paramsAddress.address,
				province_id: this.paramsAddress.province.id,
				province_name: this.paramsAddress.province.text,
				city_id: this.paramsAddress.city.id,
				city_name: this.paramsAddress.city.text,
				subdistrict_id: this.paramsAddress.subdistrict.id,
				subdistrict_name: this.paramsAddress.subdistrict.text,
				lat: this.location.lat,
				lng: this.location.lng,
			}
			this.saveAddress(params).then(() => {
				if (this.responSukses == 200) {
					let data = Object.assign({}, this.userData)
					data['stockist_origin_province_id'] = this.paramsAddress.province.id
					data['stockist_origin_city_id'] = this.paramsAddress.city.id
					data['stockist_origin_subdistrict_id'] = this.paramsAddress.subdistrict.id
					data['stockist_origin_province_name'] = this.paramsAddress.province.text
					data['stockist_origin_city_name'] = this.paramsAddress.city.text
					data['stockist_origin_subdistrict_name'] = this.paramsAddress.subdistrict.text
					data['stockist_origin_address'] = this.paramsAddress.address
					this.setProfileData(data)
					this.$refs.modalAlamatDashboard.modalHide()
				}
			})
		},
		addToCart(code) {
			let index = [...this.dataProduk].findIndex(x => x.product_code == code);
			let val = [...this.dataProduk].filter(x => x.product_code == code);
			let data = Object.assign({}, val[0]);
			this.saveCart({product: data, index: index})
			this.$router.push({ name: 'transaction' })
		}
	},
	created() {
		this.$store.dispatch('setPageTitle', 'Dashboard');
		this.getMitra({ 'filter': 2 })
		this.getPenjualan({ 'filter': 3 })
		this.getPenjualanByYear()
		this.getSummaryStockProduct()
		this.getDataProduk({limit: 100})
	},
	mounted() {
		if (!this.userData.stockist_origin_province_id || !this.userData.stockist_origin_city_id || !this.userData.stockist_origin_subdistrict_id || !this.userData.stockist_origin_address) {
			this.$refs.modalAlamatDashboard.modalShow()
		}
	}
};
</script>

<style type="text/css">
.background-blue-light {
	background-color: #abdbf1;
}

.text-blue {
	color: #1188d7;
}
</style>
